// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3TCug","validationTips":"StatementDescriptor_validationTips__3_34_"};